import { useRef } from "react";

export const move = (arr, from, to) => {
  if (to < 0 || to >= arr.length || from === to) return arr;
  const next = [...arr];
  const [x] = next.splice(from, 1);
  next.splice(to, 0, x);
  return next;
};

export const useDragReorder = (list, onChange) => {
  const from = useRef(null);
  return (i) => ({
    draggable: true,
    onDragStart: (e) => { from.current = i; e.dataTransfer.effectAllowed = "move"; e.dataTransfer.setData("text/plain", String(i)); },
    onDragOver: (e) => { e.preventDefault(); e.dataTransfer.dropEffect = "move"; },
    onDrop: (e) => {
      e.preventDefault();
      if (from.current !== null) onChange(move(list, from.current, i));
      from.current = null;
    },
  });
};
